import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { RotatingSquare } from "react-loader-spinner";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";

const Sponsors = () => {
    const { authUser } = useContext(AuthContext);
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState([]);
    const [userUpdateData, setuserUpdateData] = useState({});

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/user/view/single/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setUserData(data.data);
            });
    }, [userUpdateData]);


    const refSubmitDis = useRef();
    // Balance Add








    return (

        <>

            <div className="card mt-30">
                <div className="card-header">
                    <h5 className="card-title mb-0">
                        Sponsors of 00000
                    </h5>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle">
                            <tbody>
                                <tr>
                                    <td>Level # 1</td>
                                </tr>
                                <tr>
                                    <td>Level # 2</td>
                                </tr>
                                <tr>
                                    <td>Level # 3</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>

    );

};

export default Sponsors;
